/**
 * Convert Invoices container state into a normalized model for print templates.
 * Keep this file free of React/jsPDF concerns.
 */

export function buildInvoicePrintModel(state) {
  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));
  const safeNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const items = (state.invoiceItemList || []).map((item, idx) => {
    const qty = safeNum(item.quantity);
    const rate = safeNum(item.price);
    const amount = qty * rate;
    return {
      sno: idx + 1,
      description: safeStr(item.des || item.description),
      hsnCode: safeStr(item.hsncode),
      partNum: safeStr(item.partnum),
      countryOfOrigin: safeStr(item.con),
      netWeightKg: safeNum(item.netwt),
      quantity: qty,
      rateUsd: rate,
      amountUsd: amount,
    };
  });

  const boxes = (state.invoiceBoxList || []).map((box, idx) => ({
    idx: idx + 1,
    boxNo: safeStr(box.boxno),
    grossWeightKg: safeNum(box.boxwt),
    netWeightKg: safeNum(box.boxnetwt),
    lCm: safeNum(box.boxl),
    wCm: safeNum(box.boxb),
    hCm: safeNum(box.boxw),
  }));

  const totals = {
    totalQty: items.reduce((s, it) => s + it.quantity, 0),
    totalAmountUsd: items.reduce((s, it) => s + it.amountUsd, 0),
    totalPackages: boxes.length,
    totalGrossWeightKg: boxes.reduce((s, b) => s + b.grossWeightKg, 0),
    totalNetWeightKg: boxes.reduce((s, b) => s + b.netWeightKg, 0),
  };

  return {
    meta: {
      invNo: safeStr(state.invNo),
      invDate: state.invDate ? new Date(state.invDate) : null,
      ieCode: safeStr(state.ieCode),
      ordNo: safeStr(state.ordNo),
      ordDate: state.ordDate ? new Date(state.ordDate) : null,
    },
    exporter: {
      name: safeStr(state.expName),
      address: safeStr(state.fromAddr),
      contactPerson: safeStr(state.expConPer),
      phone: safeStr(state.expPerNo),
      email: safeStr(state.expPerEmail),
    },
    consignee: {
      name: safeStr(state.consName),
      address: safeStr(state.toAddr),
      contactPerson: safeStr(state.conConPer),
      phone: safeStr(state.conPerNo),
      email: safeStr(state.conPerEmail),
    },
    carrier: {
      buyerId: safeStr(state.buyerId),
      countryManufacture: safeStr(state.conMan),
      countryExport: safeStr(state.conExp),
      countryDestination: safeStr(state.conDest),
    },
    shipping: {
      preCarriageBy: safeStr(state.preCarr),
      vesselOrFlightNo: safeStr(state.flightNo),
      portDischarge: safeStr(state.portDis),
      placeReceiptByPreCarrier: safeStr(state.placeRecip),
      portLoading: safeStr(state.portLoad),
      finalDestination: safeStr(state.finalDest),
    },
    payment: {
      termsDeliveryPayment: safeStr(state.termsDnP),
      freight: safeStr(state.freight),
      companyLUT: safeStr(state.companyLUT),
    },
    items,
    boxes,
    totals,
  };
}


